import { m8API } from 'services/production/m8';
import { ConfirmGiroPaymentService } from 'types/services';

export const confirmGiroPayment: ConfirmGiroPaymentService = async (params) => {
  await m8API.admin.releaseStatement({
    idStatement: params.giroPaymentId,
  });
};
